import styled from 'styled-components';
import Container from '@components/common/Container';
import { Typography } from '@components/common/Typography';

export const Title = styled(Typography)`
  padding-bottom: 16px;
`;

export const Wrapper = styled(Container)`
  padding: 120px 104px;
  display: flex;
  justify-content: space-between;
  & > div {
    width: 410px;
    max-width: 95%;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    flex-direction: column;
    padding: 80px 0;
    img {
      width: 60% !important;
      margin-top: 40px;
    }
    & > div {
      width: 100%;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    img {
    width: 100% !important;
  }

`;

export const LeverageBackground = styled.div`
  background: url('/home/leverage-background.svg') center center no-repeat;
  background-size: cover;
  img {
    width: 478px;
    aspect-ratio: 1.5;
  }
`;
export const LiquidityBackground = styled.div`
  background: url('/home/liquidity-background.svg') center center no-repeat;
  background-size: cover;
  img {
    width: 453px;
    aspect-ratio: 1.4;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    ${Wrapper} {
      flex-direction: column-reverse;
    }
  }
`;

export const Label = styled.p`
  padding-bottom: 16px;
  font-size: 14px;
`;

export const APY = styled(Typography)`
  padding: 30px 0 6px;
  color: ${({ theme }) => theme.colors.primary.main};
`;
